import {
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
} from '@material-ui/core';
import * as lib from '~/dependencies';

export const Dialog = lib.styled(MuiDialog)`
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .MuiCircularProgress-colorPrimary {
    color: #29cf6a;
    opacity: 1!important;
  }
`;

export const DialogContent = lib.styled(MuiDialogContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
`;
